export const noticeModals = {
  loginUpdate: {
    title: "Novidade!",
    subtitle:
      "Agora você pode criar uma conta no Bible Journey para poder acessar seu plano bíblico de qualquer lugar 🎉",
    firstButton: "Vou criar conta depois",
    secondButton: "Criar conta agora",
  },
};
